var map = {
	"./cantonese_zh.png": 588,
	"./cn/vocab_icon.png": 486,
	"./english/vocab_icon.png": 487,
	"./english_english.png": 589,
	"./footer.png": 590,
	"./header.png": 591,
	"./putonghua_cn.png": 592,
	"./putonghua_cn_my.png": 593,
	"./putonghua_zh.png": 594,
	"./return.png": 488,
	"./stroke_order.png": 489,
	"./zh/vocab_icon.png": 490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1554;